import { useMemo } from 'react';

import { useEcomStoreSelector } from '@/data';
import { FulfillmentType } from '@/types';

const useFulFillmentType = () => {
  const {
    delivery_details: { pickup, delivery },
    provider_inventory_location_id,
  } = useEcomStoreSelector([
    'delivery_details',
    'provider_inventory_location_id',
  ]);

  const fulfillmentType = useMemo(() => {
    if (pickup) return FulfillmentType.PICKUP;
    if (delivery) return FulfillmentType.DELIVERY;

    return undefined;
  }, [pickup, delivery, provider_inventory_location_id]);

  return { fulfillmentType };
};

export { useFulFillmentType };
